import { type QueryHookOptions, useQuery } from "@apollo/client";
import { VideoDownloadQuery } from "../graphql/queries";
import type {
  VideoDownloadQueryType,
  VideoDownloadQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useVideoDownloadQuery = (
  options?: QueryHookOptions<
    VideoDownloadQueryType,
    VideoDownloadQueryVariablesType
  >
) => {
  return useQuery<VideoDownloadQueryType, VideoDownloadQueryVariablesType>(
    VideoDownloadQuery,
    options
  );
};
